import "./../../bindings/bao-date-time-box";
import "./../../bindings/bao-date-time-picker";
import "./../../bindings/bao-number-box";
import "./../../bindings/validate";
import "./../../bindings/sorting";
import "./../../bindings/foreach-selection";
import "./../../services/bao-router";
import "./../../bindings/bao-searcher";
import "./../../bindings/filtering";
import "./../../bindings/bao-upload";
import * as ko from "knockout";
import Bao from "./../../services/bao-service";
import BaoDialog from "./../../factories/bao-dialog";

/**
 * Class representing the dialog for WorkItemTabUniversalField.
 */
class WorkItemTabUniversalFieldDialog {

    //#region Fields
    public Bao: typeof Bao = Bao;
    public Dialog: BaoDialog;
    public Model: any;
    public UniversalfieldName: KnockoutObservable<string> = ko.observable("");
    public UniversalFieldId: KnockoutObservable<string> = ko.observable("");
    public Key: KnockoutObservable<string> = ko.observable("");
    public ShiftTypeName: KnockoutObservable<string> = ko.observable("");
    public ShiftTypeId: KnockoutObservable<string> = ko.observable("");
    public WorkItemTabId: KnockoutObservable<string> = ko.observable("");
    //#endregion

    //#region Constructors
    /**
     * Initializes a new instance of the WorkItemTabUniversalFieldDialog class.
     * @param data - The initial data for the dialog.
     * @param dialog - The BaoDialog instance.
     */
    constructor(data: any, dialog: BaoDialog) {
        this.Dialog = dialog;
        $.extend(this, data);
        data.Parent.ItemCompleteCheck = this.ItemCompleteCheck;
    }
    //#endregion

    //#region Public Methods
    /**
     * Checks if the item is complete.
     * @param item - The item to be checked.
     * @returns A promise indicating the check result.
     */
    ItemCompleteCheck = (item: any): JQueryPromise<boolean> => {
        const def: JQueryDeferred<boolean> = $.Deferred<boolean>();
        let result: boolean = true;

        if (Bao.Utils.String.IsNullOrWhitespace(this.UniversalfieldName())) {
            result = false;
        }

        if (!result) {
            new BaoDialog(Bao.Session.ApplicationName, Bao.Session.GetMessage("msgFillMandatorFields"), "info");
        }

        def.resolve(result);
        return def.promise();
    };
    //#endregion
}
export default WorkItemTabUniversalFieldDialog;